import { Fragment } from "react";
import { useWatch } from "react-hook-form";
import { parseFormTemplate } from "./formTemplateParser";
import { CONTEXT_SAMPLE_VALUES } from "./placeholders";
import styles from "./FormPreview.module.scss";

interface IFormPreviewProps {
  fieldName: string;
}

export const FormPreview = ({ fieldName }: IFormPreviewProps) => {
  const template: string = useWatch({ name: fieldName }) ?? "";
  const segments = parseFormTemplate(template);

  return (
    <div className={styles.root}>
      <div className={styles.title}>Преглед</div>
      <div className={styles.body}>
        {segments.length === 0 && (
          <span className={styles.empty}>
            Тук ще виждате как изглежда формата за потребителя.
          </span>
        )}
        {segments.map((segment, index) => {
          switch (segment.type) {
            case "break":
              return <br key={index} />;
            case "context":
              return (
                <span key={index} className={styles.context}>
                  {CONTEXT_SAMPLE_VALUES[segment.value] ?? ""}
                </span>
              );
            case "input":
              return <span key={index} className={styles.input} />;
            case "textarea":
              return <span key={index} className={styles.textarea} />;
            default:
              return <Fragment key={index}>{segment.value}</Fragment>;
          }
        })}
      </div>
    </div>
  );
};
